import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Title for create customer modal',
    defaultMessage: 'Create New Customer',
    id: 'enR5XF',
  },
  customerInfo: {
    description: 'Customer info section header',
    defaultMessage: 'Customer Information',
    id: '21qWG1',
  },
  nameRequired: {
    description: 'Error message for required name',
    defaultMessage: 'Name is required',
    id: '8kZDHD',
  },
  nameInvalid: {
    description: 'Error message for invalid name format',
    defaultMessage: 'Name must be at least 2 characters and contain at least one letter',
    id: '3ZC+yN',
  },
  emailRequired: {
    description: 'Error message for required email',
    defaultMessage: 'Email is required',
    id: 'LCYgJJ',
  },
  emailInvalid: {
    description: 'Error message for invalid email',
    defaultMessage: 'Please enter a valid email address',
    id: 'N0LR2N',
  },
  cancel: {
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
    id: 'hHNj31',
  },
  createCustomer: {
    description: 'Create customer button text',
    defaultMessage: 'Create Customer',
    id: 'Q5149N',
  },
  editTitle: {
    description: 'Title for edit customer modal',
    defaultMessage: 'Edit Customer',
    id: '14csYM',
  },
  updateCustomer: {
    description: 'Button text for updating customer',
    defaultMessage: 'Update Customer',
    id: 'BGqdIJ',
  },
});
